import { render, staticRenderFns } from "./BikkuraponModals.vue?vue&type=template&id=30b2d3ba&scoped=true&"
import script from "./BikkuraponModals.vue?vue&type=script&lang=js&"
export * from "./BikkuraponModals.vue?vue&type=script&lang=js&"
import style0 from "./BikkuraponModals.vue?vue&type=style&index=0&id=30b2d3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b2d3ba",
  null
  
)

export default component.exports